<template>
  <div class="l-page l-page--message">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="l-main-head">
        <div class="c-title u-w600">
          <div class="c-title__text c-title__text--blue u-fs34">{{ message ? message.message_name : 'ユニークキー配信の詳細' }}</div>
        </div>
        <button
          v-if="message && message.is_stoppable"
          type="button"
          class="c-btn c-btn--gray u-w250"
          @click="isStopping = true"
        >
          <p class="c-btn__text">配信を停止する</p>
        </button>
      </div>
      <div class="l-main-content">
        <div v-if="!message" class="c-loader c-loader"></div>
        <div v-else class="unique-key-message-review">
          <dl class="unique-key-message-review__table">
            <div class="unique-key-message-review__row">
              <dt>状態</dt>
              <dd>{{ deliverStatusLabels[message.deliver_status] }}</dd>
            </div>
            <div class="unique-key-message-review__row">
              <dt>配信日時</dt>
              <dd>{{ getDisplayDateTime(message.send_start_date) }}（{{ message.delivery_type == 4 ? '即時' : '予約' }}）</dd>
            </div>
            <div class="unique-key-message-review__row">
              <dt>配信先</dt>
              <dd>
                <a v-if="list && list.delete_flag == 0" class="unique-key-message-review__link" :href="listUrl">
                  {{ list.list_name }}（{{ Number(list.key_count).toLocaleString() }} キー）
                </a>
                <span v-else-if="list">{{ list.list_name }}（削除済みのリスト）</span>
                <span v-else>API から配信（キー数 {{ targetCount.toLocaleString() }}）</span>
              </dd>
            </div>
            <div class="unique-key-message-review__row">
              <dt>タイトル</dt>
              <dd>{{ message.message_title }}</dd>
            </div>
            <div class="unique-key-message-review__row">
              <dt>本文</dt>
              <dd class="unique-key-message-review__text">{{ message.message_text }}</dd>
            </div>
            <div class="unique-key-message-review__row">
              <dt>遷移先URL</dt>
              <dd class="unique-key-message-review__url">{{ message.click_url }}</dd>
            </div>
          </dl>

          <section>
            <h2 class="unique-key-message-review__heading">配信結果</h2>
            <p v-if="!summary" class="unique-key-message-review__muted">まだ集計されていません。配信後に集計されます。</p>
            <template v-else>
              <dl class="unique-key-message-review__metrics">
                <div>
                  <dt>配信数</dt>
                  <dd>{{ formatCount(summary.distribution_count) }}</dd>
                </div>
                <div>
                  <dt>表示数</dt>
                  <dd>{{ formatCount(summary.display_count) }}</dd>
                </div>
                <div>
                  <dt>クリック数</dt>
                  <dd>{{ formatCount(summary.click_count) }}</dd>
                </div>
              </dl>
              <table class="c-table unique-key-message-review__breakdown">
                <thead>
                  <tr>
                    <th class="c-table__cell--center">内訳</th>
                    <th class="c-table__cell--center u-w120">配信数</th>
                    <th class="c-table__cell--center u-w120">表示数</th>
                    <th class="c-table__cell--center u-w120">クリック数</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="row in breakdownRows" :key="row.key">
                    <td class="c-table__cell">{{ row.label }}</td>
                    <td class="c-table__cell c-table__cell--right">{{ formatCount(summary[row.key + '_count']) }}</td>
                    <td class="c-table__cell c-table__cell--right">{{ formatCount(summary['display_' + row.key + '_count']) }}</td>
                    <td class="c-table__cell c-table__cell--right">{{ formatCount(summary['click_' + row.key + '_count']) }}</td>
                  </tr>
                </tbody>
              </table>
              <p class="unique-key-message-review__muted">表示数・クリック数は毎朝集計し、送った日から3日間は数え直します。</p>
            </template>
          </section>

          <div class="unique-key-message-review__actions">
            <a class="c-btn c-btn--gray u-w200 u-h50" href="/coins-admin/unique-key-message">
              <p class="c-btn__text">一覧に戻る</p>
            </a>
          </div>
        </div>
      </div>
    </main>

    <control-modal
      ref="refStopModal"
      classes="c-modal--message-puse"
      title="この配信を停止してもよろしいですか?"
      :body="message ? `配信 : ${message.message_name}` : ''"
      cancel-button-label="キャンセル"
      enter-button-label="停止する"
      :is-active="isStopping"
      :on-close-click="onCloseStopModal"
      :on-cancel-click="onCloseStopModal"
      :on-enter-click="onEnterStopModal"
    />

    <error-modal :is-active="errorMessage !== ''" :message="errorMessage" :on-close-click="onCloseErrorModal" />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    csrfToken: String,
    messageId: Number,
    deliverStatusLabels: Object,
  },
  data() {
    return {
      message: null,
      list: null,
      summary: null,
      targetCount: 0,
      isStopping: false,
      errorMessage: '',
      // user_unique_message_summary の列名の中間部分 (<key>_count / display_<key>_count / click_<key>_count)
      breakdownRows: [
        { key: 'os_windows', label: 'OS: Windows' },
        { key: 'os_mac', label: 'OS: Mac' },
        { key: 'os_ios', label: 'OS: iOS' },
        { key: 'os_android', label: 'OS: Android' },
        { key: 'os_unknown', label: 'OS: 不明' },
        { key: 'browser_chrome', label: 'ブラウザ: Chrome' },
        { key: 'browser_safari', label: 'ブラウザ: Safari' },
        { key: 'browser_edge', label: 'ブラウザ: Edge' },
        { key: 'browser_firefox', label: 'ブラウザ: Firefox' },
        { key: 'browser_ie', label: 'ブラウザ: IE' },
        { key: 'browser_unknown', label: 'ブラウザ: 不明' },
        { key: 'device_pc', label: 'デバイス: PC' },
        { key: 'device_sp', label: 'デバイス: スマホ' },
        { key: 'device_tab', label: 'デバイス: タブレット' },
      ],
    };
  },
  computed: {
    listUrl: function () {
      return '/coins-admin/unique-key-list/review?list_id=' + this.list.list_id;
    },
  },
  mounted: function () {
    this.loadData();
  },
  methods: {
    loadData: function () {
      axios
        .get('/api/unique-key-message/get', { params: { message_id: this.messageId } })
        .then((res) => {
          this.message = res.data.message;
          this.list = res.data.list;
          this.summary = res.data.summary;
          this.targetCount = res.data.target_count;
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.errorMessage = '配信内容の取得に失敗しました。再度お試しください。';
        });
    },
    formatCount: function (value) {
      return value === null || value === undefined ? '-' : Number(value).toLocaleString();
    },
    onCloseStopModal: function () {
      this.isStopping = false;
      this.$refs.refStopModal.resetErrorMessage();
    },
    onEnterStopModal: function () {
      this.$refs.refStopModal.showLoader();
      axios
        .post('/api/unique-key-message/stop', { message_id: this.messageId })
        .then((res) => {
          this.$refs.refStopModal.hideLoader();
          if (!this.handleResponse(res, false)) {
            this.$refs.refStopModal.showErrorMessage(res.data.message);
            return;
          }
          this.isStopping = false;
          this.loadData();
        })
        .catch((error) => {
          this.handleHttpError(error);
          this.$refs.refStopModal.hideLoader();
          this.$refs.refStopModal.showErrorMessage('停止に失敗しました。再度お試しください。');
        });
    },
    onCloseErrorModal: function () {
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped>
.unique-key-message-review {
  display: grid;
  gap: 32px;
  max-width: 900px;
}
.unique-key-message-review__table {
  display: grid;
  gap: 1px;
  background: #dde3e8;
  border: 1px solid #dde3e8;
}
.unique-key-message-review__row {
  display: grid;
  grid-template-columns: 180px 1fr;
  background: #fff;
}
.unique-key-message-review__row dt {
  background: #f5f7f9;
  font-weight: bold;
  padding: 12px 16px;
}
.unique-key-message-review__row dd {
  padding: 12px 16px;
}
.unique-key-message-review__text {
  white-space: pre-wrap;
}
.unique-key-message-review__url {
  word-break: break-all;
}
.unique-key-message-review__link {
  color: #1d6fdc;
  text-decoration: underline;
}
.unique-key-message-review__heading {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 12px;
}
.unique-key-message-review__metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}
.unique-key-message-review__metrics div {
  background: #fff;
  border: 1px solid #dde3e8;
  padding: 12px 16px;
}
.unique-key-message-review__metrics dt {
  color: #666;
  font-size: 13px;
}
.unique-key-message-review__metrics dd {
  font-size: 24px;
  font-weight: bold;
  font-variant-numeric: tabular-nums;
}
.unique-key-message-review__breakdown td.c-table__cell--right {
  font-variant-numeric: tabular-nums;
}
.unique-key-message-review__muted {
  color: #666;
  font-size: 13px;
  margin-top: 8px;
}
.unique-key-message-review__actions {
  display: flex;
  gap: 16px;
  /* フッター直前で終わらないよう、右下のページトップボタンと重ならない分を空ける */
  margin-bottom: 80px;
}
</style>
